import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

function useNavbarFixedPadding() {
    const location = useLocation();
    useLayoutEffect(() => {
        const handleNavbarFixed = () => {
            const mediaQuery = window.matchMedia("(min-width: 1200px)");
            const navbar = document.querySelector("header");
            const navbarHeight = navbar ? navbar.clientHeight : 0;
            const userToolbar: HTMLElement | null = document.getElementsByClassName("users-toolbar")[0] as HTMLElement | null;

            if (mediaQuery.matches) {
                document.body.style.paddingTop = `${navbarHeight}px`;
                if (userToolbar) {
                    userToolbar.style.top = `${navbarHeight}px`;
                }
            } else {
                document.body.style.paddingTop = "0px";
                if (userToolbar) {
                    userToolbar.style.top = "0px";
                }
            }
        };

        handleNavbarFixed(); // Initial call
        window.addEventListener("resize", handleNavbarFixed);

        return () => {
            window.removeEventListener("resize", handleNavbarFixed);
            document.body.style.paddingTop = "0px";
            const userToolbar: HTMLElement | null = document.getElementsByClassName("users-toolbar")[0] as HTMLElement | null;
            if (userToolbar) {
                userToolbar.style.top = "0px";
            }
        };
    }, [location]);
}

export default useNavbarFixedPadding;
